import React from 'react'

const ProgressBarBattery = ({totalSize, maxSize, showProgressBar, position = 'right'}) => {

    const getProgressWidth = () => {

        return Math.min((totalSize / maxSize) * 70, 70);
    };

       const getProgressColor = () => {
            if (totalSize > maxSize) return "progress-red";
            if (totalSize > maxSize * 0.8) return "progress-dark-orange";
            if (totalSize > maxSize * 0.7) return "progress-orange";
            if (totalSize > maxSize * 0.2) return "progress-light-green";
            return "progress-green";
        };
  return (
    <div className={`container-general-bar-progress container-general-bar-progress--${position}`}>
                   
                    <div className={`container-progres-bar ${showProgressBar ? "show" : "hide"}`}>

                        <div className="progress-bar-container mt-1">

                            <div
                                className={`progress-bar ${getProgressColor()} transition-all duration-300`}
                                style={{ width: `${getProgressWidth()}%` }}
                            ><p className='text-in-battery'>{parseFloat(totalSize.toFixed(1))}MB</p></div>
                            <div className="container-text-bar">

                                <span className="progress-text">

                                    MAXIMO - {maxSize}MB
                                </span>
                            </div>
                        </div>

                        <div className="container">

                        </div>
                    </div>
                </div>
  )
}

export default ProgressBarBattery